import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Footer from './Footer';
import Header from './Header';
import { Routes, Route, useNavigate, useLocation, Navigate } from 'react-router-dom';
import Login from './Login';
import NewEvaluation from './NewEvaluation';
import { useEffect, useState } from 'react';
import { useAuth } from './AuthProvider';
import MyAccount from './MyAccount';
import MyEvaluations from './MyEvaluations';
import HomePage from './HomePage';
import jsSHA from 'jssha';
import AllEvaluations from './AllEvaluations';
import AllEvaluationsSingleView from './AllEvaluationsSingleView';
import { jwtDecode } from 'jwt-decode';
import AboutPage from './AboutPage';

// Utility functions for PKCE
const generateRandomString = (length) => {
  const charset = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~';
  let result = '';
  for (let i = 0; i < length; i++) {
    result += charset.charAt(Math.floor(Math.random() * charset.length));
  }
  return result;
};

const base64UrlEncode = (arrayBuffer) => {
  const uint8Array = new Uint8Array(arrayBuffer);
  let binary = '';
  uint8Array.forEach((byte) => {
    binary += String.fromCharCode(byte);
  });
  return btoa(binary)
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');
};

// const createCodeChallenge = async (codeVerifier) => {
//   const encoder = new TextEncoder();
//   const data = encoder.encode(codeVerifier);
//   const digest = await crypto.subtle.digest('SHA-256', data);
//   return base64UrlEncode(digest);
// };

const createCodeChallenge = async (codeVerifier) => {
  // Create a new instance of jsSHA with SHA-256 hashing
  const shaObj = new jsSHA("SHA-256", "TEXT");
  
  // Update the SHA object with the code verifier
  shaObj.update(codeVerifier);

  // Get the hash as an ArrayBuffer
  const hashBuffer = shaObj.getHash("ARRAYBUFFER");

  // Return the Base64 URL encoded hash
  return base64UrlEncode(hashBuffer);
};

const ProtectedRoute = ({ element: Element }) => {
  // const { isAuthenticated } = useAuth();
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  // useEffect(() => {
  //   // Retrieve the access token from localStorage on component mount
  //   const token = localStorage.getItem('access_token');
  //   // todo check validity of token, instead of just checking if it exists
  //   if (token) {
  //     if (isTokenExpired(token)) {
  //       setIsAuthenticated(false);
  //       console.log("test");
  //       navigate("/login");
  //     }  else {
  //       setIsAuthenticated(true);
  //       console.log("test1");
  //     } 
  //   }
  // },[isAuthenticated, navigate]);

  // // useEffect(() => {
  // //   // Retrieve the access token from localStorage on component mount
  // //   const token = localStorage.getItem('access_token');
  // //   // todo check validity of token, instead of just checking if it exists
  // //   if (token) {
  // //     if (isTokenExpired(token)) {
  // //       setIsAuthenticated(false);
  // //       navigate("/login");
  // //     }  else {
  // //       setIsAuthenticated(true);
  // //     } 
  // //   }
  // // },[location]);

  // const isTokenExpired = (token) => {
  //   if (!token) return true;
  //   try {
  //     const decodedToken = jwtDecode(token);
  //     const currentTime = Date.now() / 1000;
  //     return decodedToken.exp < currentTime;
  //   } catch (error) {
  //     console.error('Error decoding token:', error);
  //     return true;
  //   }
  // };

  // useEffect(() => {
  //   !isAuthenticated && navigate('/login');
  // }, [location]);

  // return isAuthenticated ? <Element/> : <Login/>;
  return <Element />;

};

function App() {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated, login, logout } = useAuth();

  useEffect(() => {
    const initializeAuth = async () => {
      if (!sessionStorage.getItem('code_verifier')) {
        const codeVerifier = generateRandomString(128);
        const codeChallenge = await createCodeChallenge(codeVerifier);
        sessionStorage.setItem('code_verifier', codeVerifier);
        sessionStorage.setItem('code_challenge', codeChallenge);
      }
    };

    initializeAuth();
}, []);

  useEffect(() => {
    const handleAuthCallback = async () => {
      const searchParams = new URLSearchParams(location.search);
      const authCode = searchParams.get('code');
      const state = searchParams.get('state');
      const storedState = sessionStorage.getItem('auth_state');
      const storedCodeVerifier = sessionStorage.getItem('code_verifier');

      if (!authCode || state !== storedState) {
        console.error('Invalid state parameter or auth code missing');
        return;
      }

      const processedAuthCode = localStorage.getItem('processed_auth_code');
      if (processedAuthCode === authCode) {
        console.log('Auth code has already been processed');
        return;
      }

      if (authCode && storedCodeVerifier) {
        try {
          // todo change to env var
          const response = await fetch('http://ascola-dev01.it.auth.gr/api/authentication/callback', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ code: authCode, code_verifier: storedCodeVerifier, redirect_uri: window.location.hostname === "localhost" ? 'http://localhost:3000/authentication/callback' : 'http://ascola-dev02.it.auth.gr/authentication/callback' }),
          });

          if (response.ok) {
            const { access_token } = await response.json();
            localStorage.setItem('access_token', access_token);
            localStorage.setItem('processed_auth_code', authCode);
            login(access_token);
            // todo navigate to home page
            navigate('/my-evaluations');
          } else {
            console.error('Failed to exchange auth code for tokens:', await response.text());
          }
        } catch (error) {
          console.error('An error occurred during token exchange:', error);
        }
      } else {
        console.error('Code verifier is missing');
      }
    };

    const initializeAuth = async () => {
      if (!sessionStorage.getItem('code_verifier')) {
        const codeVerifier = generateRandomString(128);
        const codeChallenge = await createCodeChallenge(codeVerifier);
        sessionStorage.setItem('code_verifier', codeVerifier);
        sessionStorage.setItem('code_challenge', codeChallenge);
      }

      if (location.pathname === '/authentication/callback') {
        await handleAuthCallback();
      }
    };

    initializeAuth();
  }, [location, navigate, login]);

  return (
    <div className="App">
      <Header onLogout={logout} isAuthenticated={isAuthenticated} />
      <Routes>
        <Route index element={<ProtectedRoute element={HomePage} />} />
        <Route path='/login' element={<Login/>} />
        <Route path='/about' element={<AboutPage/>} />
        <Route path='/new-evaluation' element={<ProtectedRoute element={NewEvaluation} />} />
        <Route path='/edit-evaluation' element={<ProtectedRoute element={NewEvaluation} />} />
        {/* // element={isAuthenticated ? <Navigate to="/login" replace /> : <NewEvaluation />} */}
        <Route path='/authentication/callback' element={<div>Loading...</div>} />
        <Route path='/my-account' element={<ProtectedRoute element={MyAccount} />} />
        <Route path='/my-evaluations' element={<ProtectedRoute element={MyEvaluations} />} />
        <Route path='/all-evaluations' element={<ProtectedRoute element={AllEvaluations} />} />
        <Route path='/all-evaluations/:id' element={<ProtectedRoute element={AllEvaluationsSingleView} />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
